import { useState, useEffect, ReactElement } from 'react';
import { getIsDownloadUser, apiPathProducts } from '../productPageApi';
import Icon from '../../../components/Icon';

interface DownloadProps {
  catalogueRef: string | null;
}

export default function Download(props: DownloadProps): ReactElement {
  const [isDownloadUser, setIsDownloadUser] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getIsDownloadUser()
      .then((data: any) => setIsDownloadUser(data))
      .catch((error: any) => console.log(error));
  }, []);

  function getProductAssets(catalogueRef?: string | null) {
    const path = `${apiPathProducts}ExportProductDetails/?catalogueRef=${catalogueRef}`;

    const fetchBaseConfig: RequestInit = {
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/zip',
        accept: 'application/zip',
      },
    };

    fetch(path, fetchBaseConfig)
      .then((response: any) => {
        setIsLoading(false);
        if (!response.ok) {
          throw new Error('There was a problem with your request');
        }
        return response.blob();
      })
      .then((blob: any) => {
        // IE11 & Edge
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, `${catalogueRef}.zip`);
        } else {
          const blobUrl = window.URL.createObjectURL(blob);
          const downloadBtn = document.createElement('a');
          downloadBtn?.setAttribute('href', blobUrl);
          downloadBtn?.setAttribute('download', `${catalogueRef}.zip`);
          downloadBtn?.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      })
      .catch((error: any) => console.log(error));
  }

  function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    setIsLoading(true);
    getProductAssets(props.catalogueRef);
  }

  return (
    <>
      {isDownloadUser && (
        <>
          {/* Mobile */}
          <div className="product-details__download d-block d-lg-none">
            <a className="btn btn-secondary btn-block text-white" onClick={handleClick}>
              <span className="d-inline-block pr-2">
                <Icon iconName="download" modifierCss="icon--download" />{' '}
              </span>
              {isLoading ? 'Loading...': 'Download product data and images'}
            </a>
          </div>

          {/* Desktop */}
          <div className="product-details__download d-none d-lg-block">
            <a className="btn btn-link" onClick={handleClick}>
              <span className="d-inline-block pr-2">
                <Icon iconName="download" modifierCss="icon--download" />{' '}
              </span>
              {isLoading ? 'Loading...': 'Click here to download product data and images'}
            </a>
          </div>
        </>
      )}
    </>
  );
}
